// LeadDetailContext.js
import React, { createContext, useState, useContext } from "react";

const LeadDetailContext = createContext();

// Provider component
export const LeadDetailProvider = ({ children }) => {
  const [leadDetailId, setLeadDetailId] = useState(null);

  const [leadFetch, setLeadFetch] = useState(false);
  return (
    <LeadDetailContext.Provider value={{ leadDetailId, setLeadDetailId ,leadFetch, setLeadFetch }}>
      {children}
    </LeadDetailContext.Provider>
  );
};

// Custom hook for easier consumption
export const useLeadDetail = () => useContext(LeadDetailContext);
